import ApiService from '@/core/services/api.service';

const BASE = 'v1';

export const IpWhitelistService = {
  getList(params = {}) {
    return ApiService.query(`${BASE}/ip-whitelist`, { params });
  },
  getById(id) {
    return ApiService.get(`${BASE}/ip-whitelist/${id}`);
  },
  getMyIp() {
    return ApiService.get(`${BASE}/ip-whitelist/my-ip`);
  },
  create(data) {
    return ApiService.post(`${BASE}/ip-whitelist`, data);
  },
  update(id, data) {
    return ApiService.put(`${BASE}/ip-whitelist/${id}`, data);
  },
  patchStatus(id, action) {
    return ApiService.patch(`${BASE}/ip-whitelist/${id}/status`, { action });
  },
};

export const IpBypassService = {
  getList(params = {}) {
    return ApiService.query(`${BASE}/ip-bypass-exceptions`, { params });
  },
  getById(id) {
    return ApiService.get(`${BASE}/ip-bypass-exceptions/${id}`);
  },
  create(data) {
    return ApiService.post(`${BASE}/ip-bypass-exceptions`, data);
  },
  update(id, data) {
    return ApiService.put(`${BASE}/ip-bypass-exceptions/${id}`, data);
  },
  patchStatus(id, action) {
    return ApiService.patch(`${BASE}/ip-bypass-exceptions/${id}/status`, { action });
  },
  getJobTitleEnums() {
    return ApiService.get(`${BASE}/ip-bypass-exceptions/enums`);
  },
};
